import Services from './base-services'

const service = new Services('courseBook')

export default {
  getBookListByCourseAndDate(data: {userCourseId?: number, bookDate?: string, userId?: number}) {
    return service.get(`getBookListByCourseAndDate?courseId=${data.userCourseId}&date=${data.bookDate}&userId=${data.userId}`, undefined, false)
  }
}
